import React from 'react';
import { BsBoxArrowDown } from '@react-icons/all-files/bs/BsBoxArrowDown';
import { BsBoxArrowUp } from '@react-icons/all-files/bs/BsBoxArrowUp';
import { ButtonGroupField, ToggleField } from '@bucketplace/commerce-admin-ui';

import { FormContent, InspectorFormProvider } from '../../components';
import { DocumentInspectorProps } from '../../types';
import { AccordionProps } from './Accordion';

const BUTTON_PLACEMENT_OPTIONS = [
  {
    text: <BsBoxArrowUp />,
    value: 'top',
  },
  {
    text: <BsBoxArrowDown />,
    value: 'bottom',
  },
];

export function AccordionInspector({
  value,
  onChange,
}: DocumentInspectorProps<AccordionProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <FormContent header="버튼 위치">
        <ButtonGroupField
          name="buttonPlacement"
          width="100%"
          options={BUTTON_PLACEMENT_OPTIONS}
        />
      </FormContent>
      <FormContent header="최초 펼침 상태">
        <ToggleField name="initialExpanded" />
      </FormContent>
      <FormContent header="살짝 보여주기">
        <ToggleField name="peekable" />
      </FormContent>
    </InspectorFormProvider>
  );
}
